import React, { useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "./../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import FunFactsArchitecture2 from "../../components/FunFacts/FunFactsArchitecture2";
import Gallery from "../../components/Gallery/Gallery";
import ContactArchitecture from "../../components/ContactUs/ContactArchitecture";
import FooterOne from "../../components/Footer/FooterOne";
import CTAOne from "../../components/CTA/CTAOne";

const Architecture = () => {
  const home = useRef();
  const about = useRef();
  const sales = useRef();
  const service = useRef();
  const agents = useRef();
  const rentals = useRef();
  const contact = useRef();

  // const paragraph2 = (
  //   <>
  //     {`Here's How ${new Date().getFullYear()} Is Adding Up So Far:`}
  //     <br />
  //     {`YTD Average Price Comparison of All Property Types`}
  //   </>
  // );
  
  const scrollToSection = (e, content) => {
    e.preventDefault();
    switch (content) {
      case "home":
        home.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "about":
        about.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "sales":
        sales.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "service":
        service.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "agents":
        agents.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "rentals":
        rentals.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "contact":
        contact.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
    }
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Loader>
      <HeaderOne scrollToSection={scrollToSection} />

      <h2>CURRENT RENTALS</h2>
      <br />

      <Gallery
        title="PROPERTIES FOR RENTAL"
        tagline="Currently ON MARKET"
        classAppend="mt-150"
        ref={rentals}
        filter="rentals"
      />

<FunFactsArchitecture2 title={new Date().getFullYear()} tagline="By The Numbers" paragraph1="In 2024, the Manhattan luxury market registered 1,295 contracts signed at $4 million and above, an 8.5% increase over 2023. The total volume was $11,163,926,914 compared to 2023’s $9,984,115,836. One leading indicator of the luxury market can be found in Federal Reserve data: In 2020, the total net worth of the top 1% in the US was $30.3 trillion. By the 2nd  quarter of 2024, that number grew to $46.7 trillion." paragraph2={`Here is how ${new Date().getFullYear()} is shaping up so far`} paragraph3={`FOR PROPERTIES $4 MILLION AND ABOVE`} />


      <ContactArchitecture
        title="CONTACT OLSHAN"
        tagline="Connect to Your New Home"
        classAppend="mt-50"
        ref={contact}
      />

      <CTAOne
        tagline="Olshan Luxury Report"
        title="Highly focused. Data Driven."
        textButton="GET THE LATEST LUXURY REPORT"
        linkButton="/market-report"
        bg="color"
      >
        This report is the only one of its kind. On a weekly basis, Olshan
        publishes a report covering all the contract activity in the luxury
        market on properties at $4 million and above. The free report draws
        subscribers from all over the world, and is frequently quoted in the New
        York Times, Wall Street Journal, Crain's, Observer, The Real Deal and
        various media outlets.
      </CTAOne>
      <FooterOne />
    </Loader>
  );
};

export default Architecture;
